import React, { useEffect, useRef, useState } from "react";
import "./GooglePlacesApi.scss";
import { GOOGLE_PLACES_API_KEY } from "../../../../utils/constants";
import { parseGooglePlace } from "../../../../utils/googleMapsUtils";

let autoComplete;

const SearchLocationInput = ({
    setSelectedLocation,
    setAddressDetail,
    userAddress,
    onChange,
    handleBlur,
    formik,
    className,
    type,
    query,
    setQuery,
    isLoaded, // Added isLoaded prop
}) => {
    const DEFAULT_ADDRESS = "Utah, USA";
    const DEFAULT_LAT_LNG = { lat: 39.321, lng: -111.0937 };

    const autoCompleteRef = useRef(null);

    const handleScriptLoad = () => {
        if (typeof window === "undefined" || !window.google || !window.google.maps || !window.google.maps.places) {
            console.warn("Google Places API not available, functioning as standard input");
            return;
        }
        if (!autoCompleteRef.current) {
            return;
        }

        try {
            autoComplete = new window.google.maps.places.Autocomplete(autoCompleteRef.current, {
                fields: ["address_components", "formatted_address", "geometry"],
                types: ["address"],
            });

            if (autoComplete) {
                autoComplete.addListener("place_changed", () => {
                    const place = autoComplete.getPlace();
                    if (!place || !place.formatted_address) {
                        return;
                    }
                    const location = parseGooglePlace(place);
                    setQuery(location.streetAddress || place.formatted_address);
                    if (place.geometry && place.geometry.location) {
                        const latLng = {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                        };

                        setAddressDetail(location);
                        setSelectedLocation(latLng);

                        if (formik) {
                            formik.setFieldValue(type === "billing" ? "billingAddress" : "shippingaddress", location.streetAddress || place.formatted_address);
                            formik.setFieldValue(type === "billing" ? "billingCity" : "city", location.city);
                            formik.setFieldValue(type === "billing" ? "billingZipcode" : "zipcode", location.zipCode);
                        }
                    }
                });
            }
        } catch (error) {
            console.error("Error initializing Autocomplete:", error);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    };

    useEffect(() => {
        if (isLoaded && !userAddress?.disableAutocomplete) {
            handleScriptLoad();
        }
    }, [isLoaded, userAddress?.disableAutocomplete]);

    useEffect(() => {
        // Set default address if needed
        if (!userAddress?.address && !query) {
            setQuery(DEFAULT_ADDRESS);
            setSelectedLocation(DEFAULT_LAT_LNG);
            if (formik && !formik.values.shippingaddress) {
                formik.setFieldValue("shippingaddress", DEFAULT_ADDRESS);
            }
        }

        return () => {
            if (autoComplete) {
                window.google?.maps?.event?.clearInstanceListeners(autoComplete);
            }
        };
    }, []);

    return (
        <div className={`search-location-input ${className || ""}`}>
            <label>
                Enter your {type === "billing" ? "Billing" : "Shipping"} address
            </label>
            <textarea
                ref={autoCompleteRef}
                className="form-control"
                onChange={(event) => {
                    setQuery(event.target.value);
                    onChange(event);
                }}
                onKeyDown={handleKeyDown}
                placeholder="Search Places ..."
                value={query || ""}
                onBlur={handleBlur}
                autoComplete="new-password"
                id={`${type}-address-autocomplete`}
                // style={{ width: '100%', minHeight: '60px', borderRadius: '16px', padding: '12px 16px', resize: 'none', lineHeight: '1.4' }}
                rows={2}
            />
            {formik?.touched[
                type === "billing" ? "billingAddress" : "shippingaddress"
            ] &&
                formik?.errors[
                type === "billing" ? "billingAddress" : "shippingaddress"
                ] && (
                    <p className="error_message_input">
                        {
                            formik?.errors[
                            type === "billing" ? "billingAddress" : "shippingaddress"
                            ]
                        }
                    </p>
                )}
        </div>
    );
};

export default SearchLocationInput;
